import {
  Box,
  chakra,
  ComponentMultiStyleConfig,
  Flex,
  HStack,
  Image,
  useMultiStyleConfig,
  VStack,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";

export type CommentBlockItemProps = {
  id: string;
  userId: string;

  photoUrl: string | undefined; // TODO もしかしたら () => Promise<string> も受け取れるようにすべきかも。
  userName: string;
  postedAt: Date;
  content: string;

  photoPlaceholderUrl: string | undefined;
  formatPostedAt: (datetime: Date) => string;
} & ComponentStyleProps;

export const CommentBlockItem = ({
  id,
  userId,

  photoUrl,
  userName,
  postedAt,
  content,

  photoPlaceholderUrl,
  formatPostedAt,

  ...rest
}: CommentBlockItemProps) => {
  const styles = useMultiStyleConfig("CommentBlockItemStyles", {});

  const formattedPostedAt = useMemo(() => formatPostedAt(postedAt), [postedAt]);

  return (
    <VStack {...rest} align="flex-start" __css={styles.container}>
      <HStack __css={styles.header}>
        <Image
          src={photoUrl}
          fallbackSrc={photoPlaceholderUrl}
          alt={userName}
          __css={styles.photo}
        />
        <Flex direction="row" wrap="nowrap" align="baseline">
          <chakra.span __css={styles.userName}>{userName}</chakra.span>
          <chakra.span __css={styles.postedAt}>{formattedPostedAt}</chakra.span>
        </Flex>
      </HStack>
      <Box __css={styles.content}>{content}</Box>
    </VStack>
  );
};

export const CommentBlockItemStyles: ComponentMultiStyleConfig = {
  parts: ["container", "header", "photo", "userName", "postedAt", "content"],
  baseStyle: {
    container: {},
    header: {
      mb: "1",
    },
    photo: {
      mr: 2,

      boxSize: "8",
      borderWidth: "1px",
      borderColor: "gray.200",
      borderRadius: "full",
    },
    userName: {
      mr: 2,

      fontSize: "md",
      fontWeight: "bold",
      color: "gray.700",
    },
    postedAt: {
      fontSize: "sm",
      fontWeight: "normal",
      color: "gray.500",
    },
    content: {
      textAlign: "left",
      fontSize: "sm",
      color: "gray.900",
    },
  },
};
